
/* ============================================================
   AV-99: Shopify Cookie Banner Accessibility JS Overrides
   Injected by Melinda's Accessibility Tool
   ============================================================ */
(function() {
  'use strict';

  var BANNER_SELECTORS = '.shopify-pc__banner, #shopify-pc__banner, [id*="cookie-banner"], [class*="cookie-banner"], .shopify-privacy-banner';

  function isBannerContainer(el) {
    if (!el) return false;
    if (el.id === 'shopify-pc__banner') return true;
    if (typeof el.className === 'string' && el.className.indexOf('shopify-pc__banner') !== -1) return true;
    if (!/^(SECTION|DIV|ASIDE)$/i.test(el.tagName)) return false;
    return !!el.querySelector('button, a, input, [role="button"]');
  }

  function getBanner() {
    var banners = document.querySelectorAll(BANNER_SELECTORS);
    for (var i = 0; i < banners.length; i += 1) {
      if (isBannerContainer(banners[i])) return banners[i];
    }
    return null;
  }

  function fixBannerA11y(banner) {
    if (!banner || banner.dataset.a11yFixed) return;
    banner.dataset.a11yFixed = 'true';

    // 1. Set ARIA role — cookie banner should be an alertdialog
    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('aria-label', 'Cookie consent');
    banner.setAttribute('aria-describedby', 'cookie-banner-desc');

    // 2. Add heading structure
    var textEl = banner.querySelector('p, span, [class*="text"], [class*="message"]');
    if (textEl && !banner.querySelector('[role="heading"]')) {
      // Add a visually-hidden heading before the text
      var heading = document.createElement('h2');
      heading.className = 'sr-only';
      heading.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      heading.textContent = 'Cookie Consent';
      heading.id = 'cookie-banner-heading';
      banner.insertBefore(heading, banner.firstChild);
      banner.setAttribute('aria-labelledby', 'cookie-banner-heading');
    }

    // ID for aria-describedby
    if (textEl && !textEl.id) {
      textEl.id = 'cookie-banner-desc';
    }

    // 3. Fix button roles and labels
    var buttons = banner.querySelectorAll('button');
    buttons.forEach(function(btn) {
      var text = (btn.textContent || '').trim().toLowerCase();

      if (!btn.getAttribute('aria-label')) {
        if (/accept|allow|agree/i.test(text)) {
          btn.setAttribute('aria-label', 'Accept cookies');
        } else if (/decline|reject|deny/i.test(text)) {
          btn.setAttribute('aria-label', 'Decline cookies');
        } else if (/settings|preferences|manage/i.test(text)) {
          btn.setAttribute('aria-label', 'Cookie preferences');
        }
      }
    });

    // 4. Fix any non-button interactive elements
    var clickables = banner.querySelectorAll('[onclick], [class*="btn"]:not(button)');
    clickables.forEach(function(el) {
      if (!/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');

        if (el.dataset.a11yActivationBound) return;
        el.dataset.a11yActivationBound = 'true';
        el.addEventListener('keydown', function(e) {
          if (e.target !== el || el.getAttribute('role') !== 'button') return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
      }
    });

    // 5. Fix iframes within cookie banner (preferences panel)
    var iframes = banner.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
      if (!iframe.getAttribute('title')) {
        iframe.setAttribute('title', 'Cookie consent preferences');
      }
    });

    // 5b. Fix <label> tags with invalid explicit roles (AV-99 cookie #3)
    var labels = banner.querySelectorAll('label[role]');
    labels.forEach(function(label) {
      var role = label.getAttribute('role');
      // Remove invalid roles from label elements - labels shouldn't have explicit roles
      if (role && role !== 'presentation' && role !== 'none') {
        label.removeAttribute('role');
      }
    });

    // 5c. Remove prohibited aria-label from generic role elements (AV-99 cookie #13)
    var generics = banner.querySelectorAll('[role="generic"][aria-label], [role="generic"][aria-labelledby]');
    generics.forEach(function(el) {
      el.removeAttribute('aria-label');
      el.removeAttribute('aria-labelledby');
    });
    // Also check elements that implicitly have generic role (span, div without explicit role)
    var allEls = banner.querySelectorAll('[aria-label]');
    allEls.forEach(function(el) {
      var role = el.getAttribute('role');
      var tag = el.tagName.toLowerCase();
      // span elements without explicit role have implicit generic role
      if (!role && (tag === 'span') && el.getAttribute('aria-label')) {
        el.removeAttribute('aria-label');
      }
    });

    // 5d. Add heading structure to cookie category titles (AV-99 cookie #7)
    var categoryTitles = banner.querySelectorAll(
      '[class*="category"] > [class*="title"], [class*="cookie"] > [class*="title"], ' +
      '[class*="group"] > [class*="name"], [class*="consent"] [class*="heading"]'
    );
    categoryTitles.forEach(function(title) {
      if (title.tagName !== 'H2' && title.tagName !== 'H3' && !title.getAttribute('role')) {
        title.setAttribute('role', 'heading');
        title.setAttribute('aria-level', '3');
      }
    });

    // 6. Add live region for status updates
    var liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'sr-only';
    liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
    liveRegion.id = 'cookie-banner-status';
    banner.appendChild(liveRegion);

    // Announce when cookies are accepted/declined
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var text = (btn.textContent || '').trim();
        var status = document.getElementById('cookie-banner-status');
        if (status) {
          status.textContent = text + ' - cookie preferences saved';
        }
      });
    });
  }

  // MutationObserver to catch dynamically-injected cookie banners
  function observeBanner() {
    var existing = getBanner();
    if (existing) {
      fixBannerA11y(existing);
    }

    var observer = new MutationObserver(function(mutations) {
      var banner = getBanner();
      if (banner && !banner.dataset.a11yFixed) {
        fixBannerA11y(banner);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBanner);
  } else {
    observeBanner();
  }
})();

/* ============================================================
   AV-99: Additional cookie banner hardening for April 2026 retest
   ============================================================ */
(function() {
  'use strict';

  var BANNER_SELECTORS = '.shopify-pc__banner, #shopify-pc__banner, [id*="cookie-banner"], [class*="cookie-banner"], .shopify-privacy-banner';
  var lastFocusedBanner = null;
  var PREFS_WRAPPER_ID = 'shopify-pc__prefs';
  var PREFS_DIALOG_ID = 'shopify-pc__prefs__dialog';
  var PREFS_TITLE_ID = 'shopify-pc__prefs__header-title';
  var PREFS_CLOSE_ID = 'shopify-pc__prefs__header-close';

  function getText(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    for (var node = el; node; node = node.parentElement) {
      var style = window.getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }

  function hasSavedTrackingChoice() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var consent = privacy && privacy.currentVisitorConsent && privacy.currentVisitorConsent();
      return !!consent && (consent.analytics === 'yes' || consent.analytics === 'no') &&
        (consent.marketing === 'yes' || consent.marketing === 'no');
    } catch (_) {
      return false;
    }
  }

  function hideBannerAfterLateChoice(banner) {
    [100, 400, 1000, 2000].forEach(function (delay) {
      window.setTimeout(function () {
        if (banner.isConnected && hasSavedTrackingChoice()) {
          banner.style.setProperty('display', 'none', 'important');
        }
      }, delay);
    });
  }

  function isBannerContainer(el) {
    if (!el) return false;
    if (el.id === 'shopify-pc__banner') return true;
    if (typeof el.className === 'string' && el.className.indexOf('shopify-pc__banner') !== -1) return true;
    if (!/^(SECTION|DIV|ASIDE)$/i.test(el.tagName)) return false;
    return !!el.querySelector('button, a, input, [role="button"]');
  }

  function getBanner() {
    var banners = document.querySelectorAll(BANNER_SELECTORS);
    var fallback = null;
    for (var i = 0; i < banners.length; i += 1) {
      if (!isBannerContainer(banners[i])) continue;
      if (!fallback) fallback = banners[i];
      if (isVisible(banners[i])) return banners[i];
    }
    return fallback;
  }

  function ensureId(el, fallback) {
    if (!el.id) {
      el.id = fallback + '-' + Math.random().toString(36).slice(2, 8);
    }
    return el.id;
  }

  function addKeyboardActivation(el) {
    if (!el || /^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(el.tagName) || el.getAttribute('role') !== 'button' || el.dataset.a11yActivationBound) return;
    el.dataset.a11yActivationBound = 'true';
    el.addEventListener('keydown', function(e) {
      if (e.target !== el || el.getAttribute('role') !== 'button') return;
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        el.click();
      }
    });
  }

  function hasVisiblePromoUi() {
    var promoRoots = document.querySelectorAll('[id^="alia-popup-root-"], [id^="alia-root-"]');
    for (var i = 0; i < promoRoots.length; i += 1) {
      var root = promoRoots[i];
      if (root.getAttribute('aria-hidden') === 'true' || root.hidden) continue;
      if (!isVisible(root)) continue;
      var rect = root.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;
      if (/try your luck|mystery discount|claim/i.test(getText(root))) return true;
    }
    return false;
  }

  function removeDuplicateHeadings(banner) {
    var headings = Array.prototype.slice.call(
      banner.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]')
    );
    var normalized = {};

    headings.forEach(function(heading) {
      var text = getText(heading).toLowerCase();
      if (!text) return;
      if (!normalized[text]) {
        normalized[text] = heading;
        return;
      }

      if (heading.id === 'cookie-banner-heading' || heading.classList.contains('sr-only')) {
        heading.remove();
      }
    });

    var primaryHeading = banner.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"], [class*="title"], [class*="heading"]');
    if (primaryHeading) {
      if (!/^H[1-6]$/.test(primaryHeading.tagName) && !primaryHeading.getAttribute('role')) {
        primaryHeading.setAttribute('role', 'heading');
        primaryHeading.setAttribute('aria-level', '2');
      }
      banner.setAttribute('aria-labelledby', ensureId(primaryHeading, 'cookie-banner-heading'));
      banner.removeAttribute('aria-label');
    }
  }

  function removeInvalidGroupButtons(banner) {
    banner.querySelectorAll('[role="button"]').forEach(function(el) {
      if (/^(BUTTON|A|INPUT)$/.test(el.tagName)) return;
      var interactiveChildren = el.querySelectorAll('button, a, input, select, textarea, [role="button"]').length;
      if (interactiveChildren > 1 || /cookie preferences accept cookies decline cookies/i.test(getText(el))) {
        el.removeAttribute('role');
        el.removeAttribute('tabindex');
      }
    });
  }

  function fixRequiredState(banner) {
    banner.querySelectorAll('*').forEach(function(el) {
      var text = getText(el);
      if (!/^required$/i.test(text) && !/^always active$/i.test(text)) return;

      el.setAttribute('aria-label', 'Required cookies, always active');
      var owner = el.closest('button, [role="switch"], [role="checkbox"], label, [class*="toggle"], [class*="switch"]');
      if (owner) {
        owner.setAttribute('aria-disabled', 'true');
        if (!owner.hasAttribute('aria-checked')) owner.setAttribute('aria-checked', 'true');
      }
    });
  }

  function fixControls(banner) {
    banner.querySelectorAll('[onclick], [class*="btn"], [role="button"], a').forEach(function(el) {
      if (!isVisible(el)) return;
      if (!/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      }
      addKeyboardActivation(el);
    });

  }

  function hardenBanner() {
    var banner = getBanner();
    var bannerVisible = !!(banner && isVisible(banner));

    if (!bannerVisible) {
      lastFocusedBanner = null;
      return;
    }

    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('tabindex', '-1');

    removeDuplicateHeadings(banner);
    removeInvalidGroupButtons(banner);
    fixRequiredState(banner);
    fixControls(banner);

    if (banner !== lastFocusedBanner && isVisible(banner)) {
      lastFocusedBanner = banner;
      var previousFocus = document.activeElement;
      window.setTimeout(function() {
        var prefs = document.getElementById(PREFS_WRAPPER_ID);
        if (document.activeElement === previousFocus && isVisible(banner) &&
            !(prefs && isVisible(prefs)) && !hasVisiblePromoUi()) {
          banner.focus();
        }
      }, 120);
    }
  }

  function syncPreferencesModal() {
    var prefsWrapper = document.getElementById(PREFS_WRAPPER_ID);
    var prefsDialog = document.getElementById(PREFS_DIALOG_ID);
    var banner = document.getElementById('shopify-pc__banner');
    var prefsOpen = !!(prefsWrapper && prefsDialog && isVisible(prefsWrapper) && isVisible(prefsDialog));

    if (banner) {
      if (prefsOpen && banner.dataset.a11yHiddenForPrefs !== 'true') {
        banner.dataset.a11yHiddenForPrefs = 'true';
        banner.dataset.a11yDisplayBeforePrefs = banner.style.getPropertyValue('display');
        banner.dataset.a11yDisplayPriorityBeforePrefs = banner.style.getPropertyPriority('display');
        banner.dataset.a11yHadAriaHiddenBeforePrefs = banner.hasAttribute('aria-hidden') ? 'true' : 'false';
        banner.dataset.a11yAriaHiddenBeforePrefs = banner.getAttribute('aria-hidden') || '';
        banner.setAttribute('aria-hidden', 'true');
        banner.style.setProperty('display', 'none', 'important');
      } else if (banner.dataset.a11yHiddenForPrefs === 'true') {
        if (!prefsOpen) {
          if (banner.dataset.a11yHadAriaHiddenBeforePrefs === 'true') {
            banner.setAttribute('aria-hidden', banner.dataset.a11yAriaHiddenBeforePrefs);
          } else {
            banner.removeAttribute('aria-hidden');
          }
          if (hasSavedTrackingChoice()) {
            banner.style.setProperty('display', 'none', 'important');
          } else if (banner.dataset.a11yDisplayBeforePrefs) {
            banner.style.setProperty('display', banner.dataset.a11yDisplayBeforePrefs,
              banner.dataset.a11yDisplayPriorityBeforePrefs);
            hideBannerAfterLateChoice(banner);
          } else {
            banner.style.removeProperty('display');
            hideBannerAfterLateChoice(banner);
          }
          delete banner.dataset.a11yHiddenForPrefs;
          delete banner.dataset.a11yDisplayBeforePrefs;
          delete banner.dataset.a11yDisplayPriorityBeforePrefs;
          delete banner.dataset.a11yHadAriaHiddenBeforePrefs;
          delete banner.dataset.a11yAriaHiddenBeforePrefs;
        }
      }
    }

    if (!prefsOpen) return;

    var prefsTitle = document.getElementById(PREFS_TITLE_ID);
    if (prefsTitle && !getText(prefsTitle)) {
      prefsTitle.textContent = 'Cookie preferences';
    }

    var closeButton = document.getElementById(PREFS_CLOSE_ID);
    if (closeButton && !closeButton.getAttribute('aria-label')) {
      closeButton.setAttribute('aria-label', 'Close cookie preferences');
    }
  }

  function observeBanner() {
    hardenBanner();
    syncPreferencesModal();
    var observer = new MutationObserver(function() {
      hardenBanner();
      syncPreferencesModal();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBanner);
  } else {
    observeBanner();
  }
})();
